<div class="booking">

    <mat-progress-bar *ngIf="isProcessing" [mode]="progressPercent > 0 ? 'determinate' : 'indeterminate'" [value]="progressPercent" color="primary" class="transfer-progress-bar"></mat-progress-bar>

    <div class="index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="index-head">
            <span>Change Owner</span>
        </div>

        <button [attr.guide]="'transfer-lead-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button [disabled]="isProcessing" (click)="close()">
            <mat-icon>
                close
            </mat-icon>
        </button>
    </div>

    <div class="padding-10 header-info">
        <span>
            <ng-container *ngIf="typeData == 2 && totalLeads > 1">
                Select the New Owner to Transfer <strong>{{totalLeads}} Leads</strong>
            </ng-container>
            <ng-container *ngIf="typeData != 2 || totalLeads <= 1">
                Select the New Owner to Transfer the Lead
            </ng-container>
        </span>
    </div>

    <!-- Clear In-Progress Transfer Status Banner -->
    <div *ngIf="isProcessing" class="transfer-status-card" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
        <div fxLayout="column" fxFlex>
            <div class="status-title" fxLayout="row" fxLayoutAlign="space-between center">
                <span>Transfer in Progress...</span>
                <span *ngIf="progressPercent > 0" class="status-percentage">{{progressPercent}}%</span>
            </div>
            <div class="status-subtitle">
                <ng-container *ngIf="progressText">
                    {{progressText}}
                </ng-container>
                <ng-container *ngIf="!progressText">
                    <ng-container *ngIf="typeData == 2">
                        Transferring {{totalLeads}} leads to the selected owner. Please do not close or refresh this window.
                    </ng-container>
                    <ng-container *ngIf="typeData != 2">
                        Transferring lead to the selected owner. Please do not close or refresh this window.
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Error Banner if transfer failed or timed out -->
    <div *ngIf="errorMessage && !isProcessing" class="transfer-error-card" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-icon color="warn">error_outline</mat-icon>
        <div fxLayout="column" fxFlex>
            <span class="error-title">Transfer Issue</span>
            <span class="error-subtitle">{{errorMessage}}</span>
        </div>
    </div>

    <fieldset [disabled]="isProcessing" class="form-fieldset">
        <div class="padding-10" [formGroup]="firstFormGroup">
            <div fxLayout="row" *ngIf="!enableReason" fxLayout.lt-md="column" fxLayoutGap="10px">

                <div *ngIf="randomAssign==0;else other_content" fxFlex>
                    <mat-form-field fxFlex appearance="outline">
                        <mat-label>Transfer Lead </mat-label>
                        <mat-select required formControlName="userToId" [disableOptionCentering]="true" #singleSelect
                            autocomplete="off">
                            <mat-option>
                                <ngx-mat-select-search name="Owner Search" ngDefaultControl
                                    [formControl]="typeYFilterControl" placeholderLabel="Owner Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option (onSelectionChange)="checkTransferReasonEnable($event)"
                                *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.entityId">
                                {{opt.email}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="firstFormGroup.controls.userToId.errors?.required">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                </div>

                <ng-template #other_content>
                    <mat-form-field fxFlex appearance="outline">
                        <mat-label>Transfer Lead</mat-label>
                        <mat-select formControlName="ownerMultiCtrl" [disableOptionCentering]="true" [multiple]="true"
                            required #multiSelect>
                            <mat-option>
                                <ngx-mat-select-search name="Owner Search" ngDefaultControl
                                    [formControl]="typeYFilterControl" placeholderLabel="Owner Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option (onSelectionChange)="selectOwner($event,opt)"
                                *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.entityId">
                                {{opt.email}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="firstFormGroup.controls.ownerMultiCtrl.errors?.required">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                </ng-template>

            </div>

            <div *ngIf="enableReason" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Reason for Transfer</mat-label>
                    <textarea [attr.guide]="'transfer-lead-sel-transfermessage' + '__' + sanitizeUrl(url)" trim="blur" formControlName="transferMessage" matTextareaAutosize matAutosizeMinRows=1
                        matAutosizeMaxRows=5 matInput required>
                    </textarea>
                    <mat-error *ngIf="firstFormGroup.controls.transferMessage.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>
            </div>

        </div>
    </fieldset>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'transfer-lead-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-raised-button [disabled]="isProcessing" (click)="close()">
            Cancel
        </button>

        <button [attr.guide]="'transfer-lead-btn-3' + '__' + sanitizeUrl(url)" [disabled]="isSubmitDisabled" (click)="submit()" mat-raised-button color="primary">
            <span *ngIf="!isProcessing">{{text}}</span>
            <span *ngIf="isProcessing">Transferring...</span>
            <mat-icon *ngIf="isProcessing" class="btn-spinner-icon">
                <mat-spinner color="accent" diameter="18"></mat-spinner>
            </mat-icon>
        </button>
    </div>
</div>